export var hasError = function hasError(meta, disabled) {
  if (meta) {
    return (!!(meta.touched && meta.error) || !!meta.submitError && !meta.dirtySinceLastSubmit) && !disabled;
  }

  return false;
};